import type { IApiResponse } from './interfaces/IApiResponse'
import type { CreateCustomerVerification, CustomerVerification } from './interfaces/ICustomerVerification'
import type { UserInfoResponse } from './interfaces/IUserInfoResponse'
import { SboCurrency, UserInfo } from '@nami/domain/classes'
import { AccountTier, Currency } from '@nami/domain/enums'
import useAxios from './composables/useAxios'

export const customerVerificationApi = {
    get: async (type: string): Promise<CustomerVerification> => {
        const { data: response } = await useAxios.get<IApiResponse<CustomerVerification>>(
            `/v1/me/verification/type/${type}`,
        )
        return response.data
    },
    post: async (request: CreateCustomerVerification): Promise<void> => {
        await useAxios.post(`/v1/me/verification`, {
            Type: request.type,
            Value: request.value,
        })
    },
}

export const userInfoApi = {
    get: async (): Promise<UserInfo> => {
        const {
            data: { data: response },
        } = await useAxios.get<IApiResponse<UserInfoResponse>>('/v1/me')

        const cpf: string
            = Currency[response.currency.code.toUpperCase() as keyof typeof Currency] === Currency.BRL
                ? (await customerVerificationApi.get('CPF')).value
                : ''

        return new UserInfo({
            firstName: response.firstName,
            lastName: response.lastName,
            fullName: response.fullName,
            isInitialDepositDone: response.isInitialDepositDone,
            initDepositExpiredDay: response.initDepositExpiredDay,
            isKyc: response.isKyc,
            accountTier: AccountTier[response.accountTier as keyof typeof AccountTier],
            createdOn: new Date(response.createdOn),
            accountId: response.accountId,
            katakana: response.katakana,
            cpf,
            currency: new SboCurrency({
                code: Currency[response.currency.code.toUpperCase() as keyof typeof Currency],
                displayName: response.currency.displayName,
            }),
            isRequiredKyc: response.isRequiredKyc,
            isAllowUsingEwallet: response.isAllowUsingEwallet,
            residentCountryCode: response.country,
            isAllowUsingLocalPayment: response.isAllowUsingLocalPayment,
            brandName: response.brandName,
        })
    },
}
